// src/core/store/reducers/index.js
import { combineReducers } from 'redux';
import userReducer from './user';
import semesterReducer from './semester';
import permissionsReducer from './permissions';

// Combine reducers
const rootReducer = combineReducers({
  user: userReducer,
  semester: semesterReducer,
  permissions: permissionsReducer,
});

export default rootReducer;
